import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { LinkWrapper } from './ResponsibleGambling.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';

export const ResponsibleGamblingInfo = observer('ResponsibleGamblingInfo', (): JSX.Element => {
    const common = useCommon();
    const { operatorFullName: companyName, isSaferGambling } = common.features;

    const link = (): JSX.Element => {
        if (isSaferGambling.available) {
            return (
                <LinkWrapper
                    to={{
                        account: 'static',
                        static: 'safer-gambling',
                    }}
                >
                    <I18n
                        langKey='footer.commitment.safer-gambling'
                        defaultText='Safer Gambling'
                    />
                </LinkWrapper>
            );
        }

        return (
            <LinkWrapper
                to={{
                    account: 'static',
                    static: 'responsible-gambling',
                }}
            >
                <I18n
                    langKey='footer.commitment.responsible-gambling'
                    defaultText='Responsible Gambling'
                />
            </LinkWrapper>
        );
    };

    return (
        <>
            <I18n
                langKey='footer.commitment'
                defaultText='{companyName} is committed to'
                params={{ companyName }}
            />
            <br />
            {link()}
        </>
    );
});
